"use client";

import { CustomerStoryRotatorBlock } from "@mw/shared/payload-types";
import dynamic from "next/dynamic";

const BlockCustomerStoryRotator = dynamic(() =>
  import("./BlockCustomerStoryRotator").then(mod => mod.BlockCustomerStoryRotator),
);

export const BlockCustomerStoryRotatorWrapper = (props: CustomerStoryRotatorBlock) => {
  return <BlockCustomerStoryRotator {...props} />;
};
